exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchBox {\n  width: 100%; }\n\n.search_container {\n  width: 300px;\n  height: 90%;\n  opacity: 0.7;\n  border-radius: 3px;\n  background-color: white; }\n\n.searchBoxInput {\n  width: 35%;\n  color: black;\n  background-color: white;\n  border-radius: 3px;\n  float: left; }\n\ninput {\n  height: 2.2rem;\n  padding-left: 0.5rem;\n  font-family: \"browallia\", FontAwesome;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #ffffff; }\n\ninput::-webkit-input-placeholder {\n  color: black; }\n\ninput:-ms-input-placeholder {\n  color: black; }\n\ninput::-ms-input-placeholder {\n  color: black; }\n\ninput::placeholder {\n  color: black; }\n\n@media screen and (max-width: 500px) {\n  .search_container {\n    width: 100%; } }\n\n.padding-1 {\n  padding: 1rem !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-compare-to-peer-popup/trading-compare-to-peer-popup.component.scss
// module id = ../../../../../src/app/securities-level/trading-compare-to-peer-popup/trading-compare-to-peer-popup.component.scss
// module chunks = main